import Layout from "../Frames/Layout";
import Loader from "../Tools/Loader";
import Question from "./Audit/Question";
import useQuestions from "./Hooks/useAuditQuestions";
import { Add, ArrowBack } from "@mui/icons-material";
import useCreateQuestion from "./Hooks/useCreateAuditQuestion";
import { DndContext } from "@dnd-kit/core";
import {restrictToVerticalAxis} from '@dnd-kit/modifiers';
import { Button, Stack, Typography } from "@mui/material";
import useUpdateQuestion from "./Hooks/useUpdateAuditQuestion";
import { useState } from "react";
import Droppable from "./Common/Droppable";
import { Link, useParams } from "react-router-dom";
import { txt } from "../../services/translation";

export default function Audit(){

    const {id} = useParams()

    const [dragged, setDragged] = useState({})

    const questions = useQuestions()

    const createQuestion = useCreateQuestion()

    const updateQuestion = useUpdateQuestion()
    
    const onDragStart = e => {
        setDragged(e.active?.data?.current);
    }

    const onDragEnd = e => {
        setDragged(null);
        let dragged = {...e.active.data.current};
        let dropped = e.over?.data?.current;
        if(!dropped) return false;
        Object.assign(dragged, dropped);
        return updateQuestion(dragged);
    }

    return <Layout menu='design' tab='plan' style={{background: 'rgb(250,250,250)'}}>

        {questions.isFetching ? <Loader /> : 

        <DndContext 
            onDragStart={onDragStart}
            onDragEnd={onDragEnd} 
            modifiers={[restrictToVerticalAxis]}
        >

            <Stack spacing={1} sx={{maxWidth: 800, margin: 'auto'}}>

                <Typography variant='h1' sx={{my: 3}}>Grille d'audit EPP</Typography>

                <Stack direction='row' justifyContent='space-between' flexWrap='wrap-reverse'>

                    <Button startIcon={<Add />} onClick={() => createQuestion(1)}>
                        {txt('questionButton')}
                    </Button>

                    <Link to={`/design/${id}/plan`}>
                        <Button startIcon={<ArrowBack />}>
                            {txt('returnToPlanButton')}
                        </Button>
                    </Link>

                </Stack>


                <Droppable 
                    id={'question0'}
                    data={{rank: 0, isQuestion: true}}
                    disabled={!dragged?.isQuestion || dragged?.rank === 1}
                />

                {questions.data
                    .sort((a,b) => a.rank - b.rank)
                    .map((c,i) => 
                        <Question 
                            key={c.id} 
                            data={c}
                            isFirst={i === 0}
                            isLast={i === questions.data.length - 1}
                            dragged={dragged}
                        />    
                    )}

            </Stack>
        
        </DndContext>}

    </Layout>
    
}